import { Autocomplete, AutocompleteProps, TextField, TextFieldProps as TextFieldPropsType } from '@mui/material';
import { forwardRef, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';

export interface I18nOptionsAutocompleteProps extends Pick<
  AutocompleteProps<string, false, false, false>,
  'disabled' | 'value' | 'options' | 'onChange'
> {
  TextFieldProps?: Partial<TextFieldPropsType>;
  options: string[];
  i18nNs?: I18nNamespace;
  i18nKeyPrefix?: string;
}

export const I18nOptionsAutocomplete = forwardRef<any, I18nOptionsAutocompleteProps>(function I18nOptionsAutocomplete(
  { TextFieldProps, i18nNs, i18nKeyPrefix, options: optionsProp, value: valueProp, ...props },
  ref,
) {
  const { t } = useTranslation(i18nNs, { keyPrefix: i18nKeyPrefix });

  const options = useMemo(() => {
    return optionsProp
      .map((key) => ({
        key,
        value: t(key),
      }))
      .sort((a, b) => -b.value.localeCompare(a.value));
  }, [t, optionsProp]);

  const value = useMemo(() => {
    return valueProp ? { key: valueProp, value: t(valueProp) } : null;
  }, [valueProp, t]);

  return (
    <Autocomplete
      {...props}
      ref={ref}
      value={value}
      options={options}
      getOptionLabel={(option) => {
        return option?.value || '';
      }}
      renderInput={(params) => <TextField {...params} {...TextFieldProps} />}
      onChange={(event, value, reason) => {
        props.onChange?.(event, value ? value.key : null, reason);
      }}
    />
  );
});
